/**
 * Run a callback once the browser is idle, with a hard deadline.
 *
 * Extracted from `warmFingerprint.ts`, which had this inline and now calls
 * through. Used to move work off the boot critical path without dropping it
 * entirely — the `timeout` guarantees it still runs on a device that never
 * reports an idle period.
 *
 * Client-only: `requestIdleCallback` does not exist on the server, and callers
 * are expected to be in a client context already.
 */
export function whenIdle(fire: () => void, timeout = 3000): void {
  if (typeof window === 'undefined') return

  if ('requestIdleCallback' in window) {
    ;(window as Window & {
      requestIdleCallback: (cb: () => void, opts?: { timeout: number }) => void
    }).requestIdleCallback(fire, { timeout })
  } else {
    setTimeout(fire, 0)
  }
}
